const _enApiTranslation = {
  api_unknown_err: "An unknown error occured.",
};

export default _enApiTranslation;
